import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  Box,
  Button,
  Container,
  Paper,
  Typography,
  styled,
  DialogContent,
  Dialog,
  DialogTitle,
  DialogProps,
} from "@mui/material";

import fetchSeatServices from "../../queries/fetchSeatServices";
import "@duffel/components/dist/AdditionalBaggageSelection.min.css";

import { SeatSelection } from "@duffel/components";
import "@duffel/components/dist/SeatSelection.min.css";
import AddBagageCard from "../../components/AddBagageCard/AddBagageCard";
import InsuranceCard from "../../components/InsuranceCard/CheckInCard";
import parseFlightDataToKoala from "../../helpers/parseFlightDataToKoala";
import fetchKoalaOffersQuery from "../../queries/fetchKoalaOffers";
import PassengerForm from "../../components/forms/PassengerForm";
import Passenger from "../../models/Passenger";
import { useNavigate } from "react-router-dom";
import REGIONAL_JET from "../../assets/images/Regional_Jet.png";

import { colors } from "../../configs";
import Navbar from "../../components/navbar/Navbar";
import CheckInCard from "../../components/InsuranceCard/CheckInCard";
import AirlineSeatReclineNormalIcon from "@mui/icons-material/AirlineSeatReclineNormal";
const MainSectionsTitle = styled(Typography)({
  margin: "10px 20px",
});

const Checkout = () => {
  let location = useLocation();
  const navigate = useNavigate();

  const [slices, setSlices] = useState<any[]>(location?.state?.selectedOffers);
  const [passengers, setPassengers] = useState<Passenger[]>(
    location?.state?.selectedOffers[0]?.passengers
  );
  const [seatMaps, setSeatMaps] = useState<any[]>([]);
  //  const [services, setServices] = useState<any[]>([]);

  //  const [ckSeatMaps, setCkSeatMaps] = useState<any[]>();
  const [totalCost, setTotalCost] = useState<number>(0);
  const [koalaOffers, setKoalaOffers] = useState<any[]>([]);

  const [currentPassengerIdx, setCurrentPassengerIdx] = useState<any>(0);
  const [currentPassenger, setCurrentPassenger] = useState<Passenger>(
    passengers[currentPassengerIdx]
  );
  const [currentPassengerId, setCurrentPassengerId] = useState<any>(
    currentPassenger.id
  );

  const [switchingPass, setSwitchingPass] = useState<boolean>(false);
  const [passBagages, setPassBagages] = useState<any[]>([]);
  const [passSeats, setPassSeats] = useState<any[]>([]);
  const [passKoala, setPassKoala] = useState<any[]>([]);

  const [open, setOpen] = React.useState(false);
  const [fullWidth, setFullWidth] = React.useState(true);
  const [maxWidth, setMaxWidth] = React.useState<DialogProps["maxWidth"]>("lg");

  const handleSeatClickOpen = () => {
    setOpen(true);
  };

  const handleSeatClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    console.error("nEW PASSENGERS FROM PASSENGER FORM: ", passengers);

    const Single_Offerslices: any[] = [];
    let ttc = 0;
    for (let index = 0; index < slices.length; index++) {
      const offer = slices[index];
      const slice = slices[index].slices;
      Single_Offerslices.push(slice[0]);
      //  console.error("FIRST FLIGHT COST: ", offer);

      ttc += +offer.total_amount;
      setTotalCost(ttc);
    }
    for (let j = 0; j < passengers.length; j++) {
      passengers[j].koala = [];
      passengers[j].seats = [];
      passengers[j].bagages = [];
    }

    setPassengers(passengers);
    console.warn("PASSENGER_IN_KOALA", passengers);

    const koalData = parseFlightDataToKoala(
      passengers,
      Single_Offerslices,
      slices[0].base_currency,
      parseFloat(ttc.toPrecision(4))
    );
    console.warn("FINAL KOALA FLIGHT: ", koalData);
    fetchKoalaOffersQuery(koalData)
      .then((response) => response.json())
      .then((data) => {
        console.log("KOALA_OFFERS_SUCCESS", data);

        const kOffers: [] = data.data[0].quotes;
        setKoalaOffers(kOffers);

        if (!currentPassenger.koala) {
          const copyCurPass = currentPassenger;
          copyCurPass.koala = kOffers;
          setCurrentPassenger(copyCurPass);

          passengers[currentPassengerIdx] = copyCurPass;

          setPassengers(passengers);
          console.warn("PASSENGER_IN_KOALA", passengers);
        }
      })
      .catch((err) => {
        console.log("KOALA_OFFERS_ERROR", err);
      });

    fetchSeatServices(slices[0].id)
      .then((response) => response.json())
      .then((data) => {
        console.log("seat map response data ", data);

        const seatMps: any[] = data.data;

        console.log("seat map FIXED:  ", seatMps);
        setSeatMaps(seatMps);
      })
      .catch((err) => {
        console.log("fetching seat map err", err);
      });

    console.warn("OFFERS LIST IN CHECKOUT: ", slices);
    console.warn("PASSENGERS LIST IN CHECKOUT: ", passengers);
  }, [location, currentPassenger, currentPassengerIdx, passengers, slices]);
  const onSeatConfirmFn = (e: any) => {
    alert(JSON.stringify(e));
    console.log(e);
  };

  const switchPassenger = (pass: any, idx: any) => {
    setPassKoala([]);

    console.error("NEW PASSENGERS FROM PASSENGER FORM IN SWITCH: ", passengers);
    console.warn("NEW PASSENGER  PASSENGER FORM IN SWITCH: ", pass);

    setSwitchingPass(true);

    setTimeout(() => {
      setCurrentPassengerIdx(idx);
      setCurrentPassengerId(pass.id);
      setCurrentPassenger(pass);

      setSwitchingPass(false);
    }, 150);
  };
  const onInsuranceDecision = (dataFromInsurancecard: any) => {
    console.log("Déision sur assurance :", dataFromInsurancecard);
    if (dataFromInsurancecard) {
      currentPassenger.koala[dataFromInsurancecard.index] =
        dataFromInsurancecard;
      setCurrentPassenger(currentPassenger);
      console.log("====================================");
      console.log("Current pASS with koala: ", currentPassenger);
      console.log("====================================");
      passengers[currentPassengerIdx] = currentPassenger;
      setPassengers(passengers);

      console.log("====================================");
      console.log("Passanger updated with koala: ", passengers);
      console.log("====================================");
    }
  };
  /*
  const testFareOptions = () => {
    const aller = slices[0];

    console.log("====================================", aller);
    console.log("partial id: ", location.state.mainPrId);
    console.log("partial offer id: ", aller.id);
    console.log("====================================");
    fetchFareOptionsQuery(location.state.mainPrId, aller.id)
      .then((response: any) => response.json())
      .then((data) => {
        console.log("FARE OPTIONS DATA ", data);

        const dataFetc = {
          offer: data.data.offers,
        };
        console.log("FARE OPTIONS FIXED:  ", dataFetc);
      })
      .catch((err: any) => {
        console.error("fetching fare options err", err);
      });
  };
*/
  const goToResume = () => {
    let bagsCost: number = 0;
    let flightsCost: number = 0;
    let koalasCost: number = 0;
    let seatsCost: number = 0;

    passengers.map((psgrs, idx) => {
      let seats: any[] = psgrs.seats;
      let koalas: any[] = psgrs.koala;
      let bagages: any[] = psgrs.seats;
      seats.map((seat, idx) => {
        if (seat) {
          seatsCost += parseFloat(seat?.total_amount);
        } else {
          seatsCost += 0;
        }
      });
      koalas.map((koala, idx) => {
        if (koala && koala.status) {
          koalasCost += parseFloat(koala?.bundle.price.amount);
        } else {
          koalasCost += 0;
        }
      });
      bagages.map((bag, idx) => {
        bagsCost += parseFloat(bag?.available_services.total_amount);
      });
    });
    slices.map((slice, idx) => (flightsCost += parseFloat(slice.total_amount)));

    let ttc: number = parseFloat(
      (bagsCost + flightsCost + koalasCost + seatsCost).toFixed(2)
    );

    console.log("bagsCost: ", bagsCost);
    console.log("flightsCost: ", flightsCost);
    console.log("koalasCost: ", koalasCost);
    console.log("seatsCost: ", seatsCost);
    console.error("ttc: ", ttc);

    navigate(`/orderresume`, {
      replace: true,
      state: {
        //  ...location.state,
        passengers: passengers,
        offers: slices,
        koalas: koalaOffers,
        bagsCost: bagsCost,
        flightsCost: flightsCost,
        koalasCost: koalasCost,
        seatsCost: seatsCost,
        totalCoast: ttc,
      },
    });
  };

  const checkinData = {
    bundle: "Check-in done for you 24 hours before the departure",
    date: new Date(),
    expirationDate: new Date(+3),
    reference: "",
    valid: true,
    price: {
      amount: 83.99,
      currency: "EUR",
    },
  };
  return (
    <Box>
      <Box
        sx={{
          minHeight: "250px",
          backgroundColor: "#eeeeee",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-around",
          alignContent: "center",
          padding: "10px 30px",
          /*
          backgroundImage: `url(${REGIONAL_JET})`,
          backgroundPosition: "center top",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          */
          position: "relative",
        }}>
        <img
          style={{
            display: "flex",
            position: "absolute",
            zIndex: 0,
            top: -40,
          }}
          src={REGIONAL_JET}
          alt="Teksa Travel"
        />
        <Typography
          variant="h4"
          component="span"
          sx={{
            color: colors.main,
            flex: 1,
            fontWeight: "bold",
          }}>
          <pre>
            <Link to="/">Teksa Corp.</Link>
          </pre>
        </Typography>
        <Navbar />
      </Box>
      <Container>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            marginTop: "100px",
          }}>
          <Box
            sx={{
              width: "65%",
              display: "flex",
              flexDirection: "column",
            }}>
            <Paper
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 1,
                zIndex: 0,
                borderRadius: "15px",
              }}>
              <MainSectionsTitle variant="h6">
                Passenger Details
              </MainSectionsTitle>
              {switchingPass ? (
                <div>Loading passenger...</div>
              ) : (
                <>
                  {
                    passengers && (
                      /*   {  
                                        passengers.map((pass, idx) => (
                    <div
                      key={idx}
                      style={{
                        display: idx === currentPassengerIdx ? "block" : "none",
                      }}>
                     } */
                      <PassengerForm
                        currentPassenger={currentPassenger}
                        passengers={passengers}
                        currentPassengerId={currentPassenger.id}
                        currentPassengerIdx={currentPassengerIdx}
                        updatePassengers={(passPassengers: any[]) =>
                          setPassengers(passPassengers)
                        }
                      />
                    )

                    /*  {
                                      </div>
                  ))}
                  */
                  }
                </>
              )}
              <MainSectionsTitle variant="h6">Select seat</MainSectionsTitle>
              <Dialog
                fullWidth={fullWidth}
                maxWidth={maxWidth}
                open={open}
                onClose={handleSeatClose}
                aria-labelledby="responsive-dialog-title">
                <DialogTitle id="responsive-dialog-title">
                  {"Choose the quantity you want"}
                </DialogTitle>
                <DialogContent>
                  {seatMaps && (
                    <SeatSelection
                      offer={slices[0]}
                      seatMaps={seatMaps}
                      passengers={passengers}
                      onSubmit={onSeatConfirmFn}
                    />
                  )}
                </DialogContent>
              </Dialog>
              <Button
                sx={{ fontSize: "24px", color: "white" }}
                size="large"
                onClick={handleSeatClickOpen}
                variant="contained">
                + <AirlineSeatReclineNormalIcon sx={{ fontSize: "36px" }} />
                Choose your seats
              </Button>
              <MainSectionsTitle variant="h6">Bagage</MainSectionsTitle>

              {/*  
                        <Button variant="contained" onClick={() => testFareOptions()}>
              Test fares
            </Button>
            */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: "50px",
                  margin: "20px",
                }}>
                <>
                  {slices.map((slice, idx) => (
                    <AddBagageCard key={idx.toString()} offer={slice} />
                  ))}
                </>
              </Box>
              <Box>
                {koalaOffers &&
                  currentPassenger &&
                  koalaOffers.map((ksvc, idx) => (
                    <div key={idx.toString()}>
                      <MainSectionsTitle variant="h6">
                        {ksvc.bundle}
                      </MainSectionsTitle>
                      {switchingPass ? (
                        <Box>Chargement des données...</Box>
                      ) : (
                        <>
                          <InsuranceCard
                            offer={""}
                            type=""
                            onDecision={onInsuranceDecision}
                            insurance={ksvc}
                            subTitle=""
                            price={ksvc.price.amount}
                            koalaIdx={idx}
                            checkedIns={
                              currentPassenger.koala &&
                              currentPassenger.koala.length > 0
                                ? currentPassenger.koala[idx]?.status
                                : false
                            }
                          />
                        </>
                      )}
                    </div>
                  ))}
                <div>
                  <MainSectionsTitle variant="h6">
                    {"Automatic Check-In"}
                  </MainSectionsTitle>
                  {switchingPass ? (
                    <Box>Chargement des données...</Box>
                  ) : (
                    <>
                      <CheckInCard
                        offer={""}
                        type=""
                        onDecision={onInsuranceDecision}
                        insurance={checkinData}
                        subTitle="Flight stress-free, we handle everything for you."
                        price={checkinData.price.amount}
                        koalaIdx={99}
                        checkedIns={
                          currentPassenger.koala &&
                          currentPassenger.koala.length > 0
                            ? currentPassenger.koala[99]?.status
                            : false
                        }
                      />
                    </>
                  )}
                </div>
              </Box>
            </Paper>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
                alignItems: "center",
                margin: "20px 0",
              }}>
              {currentPassengerIdx === passengers.length - 1 ? (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => goToResume()}
                  sx={{
                    padding: "10px",
                    borderRadius: "5px",
                    color: "#FFFFFF",
                  }}>
                  Confirmer
                </Button>
              ) : (
                <Button
                  variant="outlined"
                  color="primary"
                  sx={{
                    padding: "10px",
                    borderRadius: "5px",
                    color: colors.main,
                  }}
                  onClick={() =>
                    switchPassenger(
                      passengers[currentPassengerIdx + 1],
                      currentPassengerIdx + 1
                    )
                  }>
                  Passager suivant
                </Button>
              )}
            </Box>
          </Box>
          <Box
            sx={{
              displa: "flex",
              flexDirection: "column",
              width: "80px",
              position: "relative",
            }}>
            {passengers && (
              <div
                style={{
                  marginTop: "15px",
                }}>
                {passengers.map((pass, idx) => (
                  <Button
                    key={idx.toString()}
                    variant="outlined"
                    onClick={() => switchPassenger(pass, idx)}
                    sx={{
                      backgroundColor:
                        currentPassengerIdx === idx ? colors.main : "#FFFFFF",
                      color:
                        currentPassengerIdx !== idx ? colors.main : "#FFFFFF",
                      fontSize: "11px",
                      borderRadius: "0 5px 5px 0",
                      padding: "15px 0",
                      "&: hover": {
                        backgroundColor: "#FFFFFF",
                        color: colors.main,
                      },
                    }}>
                    {pass.type} {idx + 1}
                  </Button>
                ))}
              </div>
            )}
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Checkout;
